import React, { useState } from "react";
import { Col, Row, Tooltip } from "reactstrap";
import InfoButtonWithTooltip from "../CPIcons/InfoToolTip";
const CPBreadCrumbMasters = ({
  title,
  pageTitle,
  data,
  selectedRange,
  onDateRangeChange,
  filterData,
  onClickSetFilter,
  onClickDownload,
}) => {
  

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">
              
              <InfoButtonWithTooltip data={data} id="toolTipMaster"/>
              {title}
            </h4>
            <div className="page-title-right d-flex align-items-center">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">{pageTitle}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CPBreadCrumbMasters;
